import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  myInnerHeight: any;
  iframeSRC: any = null;
  isLoading = true;

  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.myInnerHeight = window.innerHeight;
    this.iframeSRC = this.sanitizer.bypassSecurityTrustResourceUrl('../assets/docs/privacy-policy.html');
  }

}
